import { SET_HIDDEN_LOADING_BAR } from './types';
export const setHiddenLoadingBar = (state) => ({
    type: SET_HIDDEN_LOADING_BAR,
    payload: state
})